import React from 'react';
import PropTypes from 'prop-types';
import { isPhone } from 'utils/mobileDetect';
import { loadScript } from 'utils';
import config from 'config/config';
import staticAnimationImage from 'images/static-animation.png';
import init from './adobeFunctions';


export class AdobeAnim extends React.Component {
  static propTypes = {
    animationName: PropTypes.string.isRequired,
    composition: PropTypes.string,
    getAnimationObject: PropTypes.func,
    paused: PropTypes.bool,
    style: PropTypes.object,
  }

  static defaultProps = {
    getAnimationObject: () => {},
    composition: null,
    paused: false,
    style: {},
  }

  constructor() {
    super();

    this.state = {
      properties: {},
      error: true,
    };

    this.startAnimation = this.startAnimation.bind(this);
  }

  componentDidMount() {
    const isMobileVersion = isPhone();

    if (!isMobileVersion) this.initAnimation();
    else this.initStaticImage();
  }

  componentWillUnmount() {
    if (this.lib && !this.state.error) {
      this.lib.visible = false;
    }
  }

  initAnimation() {
    this.loadAnimationLibrary()
      .then(this.loadAnimation)
      .then(this.startAnimation)
      .catch(error => console.log(error));
  }

  loadAnimationLibrary() {
    return loadScript(config.createJsUrl);
  }

  loadAnimation() {
    return loadScript(config.homeAnimationUrl);
  }

  componentWillReceiveProps({ paused }) {
    if (this.lib && !this.state.error) {
      this.lib.tickEnabled = !paused;
    }
  }

  initStaticImage() {
    const animationReplacementImage = new Image();
    const ctx = this.canvas.getContext('2d');

    animationReplacementImage.src = staticAnimationImage;
    animationReplacementImage.onload = () => {
      ctx.canvas.width = animationReplacementImage.width;
      ctx.canvas.height = animationReplacementImage.height;
      ctx.drawImage(animationReplacementImage, 0, 0);
    };
  }

  startAnimation() {
    try {
      this.initStaticImage();

      init(
        this.props.animationName,
        this.canvas,
        this.animationContainer,
        this.domOverlayContainer,
        (l) => {
          this.props.getAnimationObject(l);
          this.lib = l;
          this.lib.tickEnabled = !this.props.paused;
        },
        properties => (this.setState({ properties })),
        this.props.composition,
      );
    } catch (e) {
      console.log('error');
      if (e.name === 'AnimateCC') console.error(`AnimateCC: ${e.message}`);

      this.setState({
        error: true,
      });
    }
  }

  render() {
    const {
      animationName,
      getAnimationObject,
      paused,
      style: additionalStyles,
      ...props
    } = this.props;

    const { properties } = this.state;

    if (Object.keys(properties).length === 0) {
      return (
        <React.Fragment>
          <div ref={(el) => { this.animationContainer = el; }}>
            <canvas ref={(el) => { this.canvas = el; }} />
            <div ref={(el) => { this.domOverlayContainer = el; }} />
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div
          ref={(el) => { this.animationContainer = el; }}
          style={{
            width: '100%',
            height: '100%',
            ...additionalStyles,
          }}
          {...props}
        >
          <canvas
            ref={(el) => { this.canvas = el; }}
            style={{
              display: 'block',
              width: '100%',
              maxWidth: '100%',
            }}
          />
          <div
            ref={(el) => { this.domOverlayContainer = el; }}
            style={{
              pointerEvents: 'none',
              overflow: 'hidden',
              width: '100%',
              height: `${properties.height}px`,
              position: 'absolute',
              left: '0px',
              top: '0px',
              display: 'block',
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/components/adobeAnim/index.js